var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTpoMasterDataSm = function SvgTpoMasterDataSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "TPO Master Data",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.002 18.363 11.592 4l6.91 14.356-6.91-8.072zm7.563-13.128-1.287 2.428 1.253 1.453 1.227-1.372z",
    "data-name": "Subtraction 2"
  })));
};
export default SvgTpoMasterDataSm;